export const SHARED_QUERIES = {
  COMPANY_PLANS: "SHARED_COMPANY_PLANS",
} as const;
